/* eslint-disable max-lines */
/* eslint-disable sort-keys */
const sharedMessageContainer = {
    '.compact &': {marginTop: 0},
    'flexDirection': 'row' as const,
    'marginTop': 10,
    'variants': {
        hidden: {true: {opacity: '.25'}},
        me: {
            true: {
                '.compact &': {flexDirection: 'row' as const},
                'flexDirection': 'row-reverse' as const,
            },
        },
        repeated: {true: {marginTop: 0}},
    },
}

export const messageContainer = {
    ...sharedMessageContainer,
    display: 'flex',
    variants: {
        ...sharedMessageContainer.variants,
        isCompose: {true: {width: '100%'}},
    },
}

export const nativeMessageContainer = {...sharedMessageContainer}

const sharedSpeechBubbleContainer = {
    flexDirection: 'column' as const,
    marginLeft: 10,
    variants: {
        me: {
            true: {
                '.compact &': {
                    marginLeft: 10,
                    marginRight: 0,
                },
                'marginLeft': 0,
                'marginRight': 10,
            },
        },
    },
}

export const speechBubbleContainer = {
    ...sharedSpeechBubbleContainer,
    compoundVariants: [
        {
            css: {
                '.compact &': {
                    marginLeft: 32,
                    marginRight: 0,
                },
                'marginLeft': 0,
                'marginRight': 40,
            },
            me: true,
            repeated: true,
        },
    ],
    display: 'flex',
    width: '100%',
    variants: {
        me: {...sharedSpeechBubbleContainer.variants.me},
        repeated: {
            true: {
                '.compact &': {marginLeft: 32},
                'marginLeft': 40,
            },
        },
    },
}

export const nativeSpeechBubbleContainer = {
    ...sharedSpeechBubbleContainer,
    compoundVariants: [
        {
            css: {marginRight: 46},
            me: true,
            repeated: true,
        },
    ],
    flexShrink: 1,
    variants: {
        me: {...sharedSpeechBubbleContainer.variants.me},
        repeated: {true: {marginLeft: 46}},
    },
}

const sharedSpeechBubble = {
    '.compact &': {
        justifyContent: 'flex-start' as const,
        border: 'none',
    },
    'alignItems': 'center' as const,
    'alignSelf': 'flex-start' as const,
    'backgroundColor': '$messageSpeechBubbleDefault',
    'borderColor': '$messageSpeechBubbleDefaultBorder',
    'borderRadius': '$messageSpeechBubbleDefault',
    'borderStyle': '$messageSpeechBubbleDefault' as const,
    'borderTopLeftRadius': '$messageSpeechBubbleDefaultCorner',
    'borderWidth': '$messageSpeechBubbleDefault',
    'compoundVariants': [
        {
            css: {borderTopRightRadius: '$messageSpeechBubbleDefault'},
            me: true,
            repeated: true,
            isEmbedQueueChannel: false,
        },
        {
            isEmbedQueueChannel: true,
            rights: 'other',
            isWriting: false,
            css: {
                'backgroundColor': '$messageSpeechBubbleOther',
                'borderColor': '$messageSpeechBubbleOtherBorder',
                'borderWidth': '$messageSpeechBubbleOther',
                'borderRadius': '$messageSpeechBubbleOther',
                'borderStyle': '$messageSpeechBubbleOther' as const,
                'color': '$messageSpeechBubbleOtherText',
                'fontFamily': '$messageSpeechBubbleOther',
                'fontWeight': '$messageSpeechBubbleOther' as any,
                'fontVariant': '$messageSpeechBubbleOther' as any,
                'fontStyle': '$messageSpeechBubbleOther' as any,
                'fontSize': '$messageSpeechBubbleOther',
                'lineHeight': '$messageSpeechBubbleOther',
                'padding': '$messageSpeechBubbleOther',
                '> div': {fontSize: '$messageSpeechBubbleOther'},
                'a': {
                    'color': '$messageSpeechBubbleOtherLink',
                    '&:hover': {color: '$messageSpeechBubbleOtherLinkHover'},
                },
                'h1, h2, h3, h4, h5, h6': {color: '$messageSpeechBubbleOtherText'},
            },
        },
        {
            isEmbedQueueChannel: true,
            rights: 'moderatorOperator',
            isWriting: false,
            css: {
                'backgroundColor': '$messageSpeechBubbleOperatorModerator',
                'borderColor': '$messageSpeechBubbleOperatorModeratorBorder',
                'borderWidth': '$messageSpeechBubbleOperatorModerator',
                'borderRadius': '$messageSpeechBubbleOperatorModerator',
                'borderStyle': '$messageSpeechBubbleOperatorModerator' as const,
                'color': '$messageSpeechBubbleOperatorModeratorText',
                'fontFamily': '$messageSpeechBubbleOperatorModerator',
                'fontWeight': '$messageSpeechBubbleOperatorModerator' as any,
                'fontVariant': '$messageSpeechBubbleOperatorModerator' as any,
                'fontStyle': '$messageSpeechBubbleOperatorModerator' as any,
                'fontSize': '$messageSpeechBubbleOperatorModerator',
                'lineHeight': '$messageSpeechBubbleOperatorModerator',
                'padding': '$messageSpeechBubbleOperatorModerator',
                '> div': {fontSize: '$messageSpeechBubbleOperatorModerator'},
                'a': {
                    'color': '$messageSpeechBubbleOperatorModeratorLink',
                    '&:hover': {color: '$messageSpeechBubbleOperatorModeratorLinkHover'},
                },
                'h1, h2, h3, h4, h5, h6': {color: '$messageSpeechBubbleOperatorModeratorText'},
            },
        },
        {
            isEmbedQueueChannel: true,
            rights: 'other',
            me: true,
            repeated: false,
            css: {'&&': {borderTopRightRadius: '$messageSpeechBubbleDefaultCorner'}},
        },
        {
            isEmbedQueueChannel: true,
            rights: 'moderatorOperator',
            me: true,
            repeated: false,
            css: {'&&': {borderTopRightRadius: '$messageSpeechBubbleDefaultCorner'}},
        },
        {
            isEmbedQueueChannel: true,
            rights: 'other',
            me: false,
            repeated: false,
            css: {'&&': {borderTopLeftRadius: '$messageSpeechBubbleDefaultCorner'}},
        },
        {
            isEmbedQueueChannel: true,
            rights: 'moderatorOperator',
            me: false,
            repeated: false,
            css: {'&&': {borderTopLeftRadius: '$messageSpeechBubbleDefaultCorner'}},
        },
    ],
    'flexDirection': 'row' as const,
    'flexWrap': 'wrap' as const,
    'marginTop': 4,
    'paddingBottom': '$messageSpeechBubblePaddingVertical',
    'paddingLeft': '$messageSpeechBubblePaddingHorizontal',
    'paddingRight': '$messageSpeechBubblePaddingHorizontal',
    'paddingTop': '$messageSpeechBubblePaddingVertical',
    'variants': {
        me: {
            true: {
                '.compact &': {alignSelf: 'flex-start' as const},
                'alignSelf': 'flex-end' as const,
                'borderTopLeftRadius': '$messageSpeechBubbleDefault',
                'borderTopRightRadius': '$messageSpeechBubbleDefaultCorner',
            },
        },
        repeated: {true: {borderTopLeftRadius: '$messageSpeechBubbleDefault'}},
        rights: {
            moderatorOperator: {true: {}},
            other: {true: {}},
        },
        isEmbedQueueChannel: {true: {}},
        isWriting: {true: {}},
    },
}

export const speechBubble = {
    fontSize: '14px',
    display: 'flex',
    lineHeight: 1.2,
    ...sharedSpeechBubble,
}

export const nativeSpeechBubble = {...sharedSpeechBubble}

const sharedNameText = {
    color: '$messageUsernameOther',
    fontSize: '$messageUsernameOther',
    fontWeight: '$messageUsernameOther' as const,
    maxWidth: 280,
    compoundVariants: [
        {
            isEmbedQueueChannel: true,
            rights: 'other',
            css: {
                color: '$messageUsernameOther',
                fontFamily: '$messageUsernameOther',
                fontWeight: '$messageUsernameOther' as const,
                fontVariant: '$messageUsernameOther' as any,
                fontStyle: '$messageUsernameOther' as any,
                fontSize: '$messageUsernameOther',
                lineHeight: '$messageUsernameOther',
            },
        },
        {
            isEmbedQueueChannel: true,
            rights: 'moderatorOperator',
            css: {
                color: '$messageUsernameOperatorModerator',
                fontFamily: '$messageUsernameOperatorModerator',
                fontWeight: '$messageUsernameOperatorModerator' as const,
                fontVariant: '$messageUsernameOperatorModerator' as any,
                fontStyle: '$messageUsernameOperatorModerator' as any,
                fontSize: '$messageUsernameOperatorModerator',
                lineHeight: '$messageUsernameOperatorModerator',
            },
        },
    ],
    variants: {
        me: {
            true: {
                '.compact &': {alignSelf: 'flex-start' as const},
                'alignSelf': 'flex-end' as const,
            },
        },
        isEmbedQueueChannel: {true: {}},
        rights: {
            other: {},
            moderatorOperator: {},
        },
    },
}

export const nameText = {
    ...sharedNameText,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
}

export const nativeNameText = {...sharedNameText}

const sharedMessageText = {
    color: '$messageText',
    fontSize: '$messageText',
}

export const nativeMessageText = {
    ...sharedMessageText,
    marginRight: 'auto',
}

const sharedMessageTime = {
    color: '$messageTimestamp',
    fontSize: '$messageTimestamp',
    marginLeft: 'auto',
    paddingLeft: '10px',
    variants: {
        isEmbedQueueChannel: {true: {}},
        rights: {
            other: {},
            moderatorOperator: {},
        },
    },
    compoundVariants: [
        {
            isEmbedQueueChannel: true,
            rights: 'other',
            css: {color: '$messageSpeechBubbleOtherTimestamp'},
        },
        {
            isEmbedQueueChannel: true,
            rights: 'moderatorOperator',
            css: {color: '$messageSpeechBubbleOperatorModeratorTimestamp'},
        },
    ],
}

export const messageTime = {
    ...sharedMessageTime,
    whiteSpace: 'nowrap',
}

export const nativeMessageTime = {...sharedMessageTime}
